export const NOT_SET = '(not set)';
export const NO_INFO = 'NO_INFO';
